import React from 'react';
import PropTypes from 'prop-types';

const DialogueItems = props => (
  <div style={{ width: '100%', display: 'inline-block' }}>
    {props.items.map(item => (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '85%',
          margin: '10px auto',
          borderBottom: '2px solid #d7d7d7',
        }}
      >
        <div style={{ display: 'flex' }}>
          <span style={{ marginRight: '6px' }}>
            <b>{item.dialogueCharacter}:</b>
          </span>
          <p
            style={{
              color:
                item.dialogueCharacter === 'STUDENT' &&
                item.type.key === 'DIALOGUE_OPTION'
                  ? 'darkgreen'
                  : 'inherit',
            }}
          >
            {item.text}
          </p>
        </div>
        {item.type.key === 'DIALOGUE_OPTION' && (
          <>
            <span>Incorrect options:</span>
            <ul>
              {item.answers.map(answer => (
                <li style={{ color: 'darkred' }}>{answer.text}</li>
              ))}
            </ul>
          </>
        )}
      </div>
    ))}
  </div>
);

DialogueItems.propTypes = {
  items: PropTypes.object,
};

DialogueItems.defaultProps = {
  items: {},
};

export default DialogueItems;
